<ng-template #timelineEsimModalFormContent role="document" let-modal>

  @if(!embeddedFormMode) {

    <app-modal-comp-header
      [button0Danger]="true"
      [button0Show]="showRiskButton"
      [button0Text]="'Riskline'"
      [showClock]="true"
      [title]="formTitle"
      (button0Click)="openRiskTripReady()"
      (cancelButtonOnClick)="closeForm()"
    ></app-modal-comp-header>

    <!--
    <app-page-comp-header
      [filterDate]="filterDate"
      [filterDateFormat]="filterDateFormat"
      [rounded]="false"
      [showCancelButton]="true"
      [showfilterDate]="true"
      [title]="formTitle"
      (cancelButtonOnClick)="closeForm()"
      (filterDateChange)="dateFilterChanged($event)"
    ></app-page-comp-header>
    -->
  }

  <div class="modal-body live-view-page-bg">
    <div class="row">
      <div [className]="embeddedFormMode && !useFullPage ? 'col-3' : 'col-0'"></div>
      <div [className]="embeddedFormMode && !useFullPage ? 'col-6' : 'col-0'">
  
        <form (ngSubmit)="saveFormData()" [formGroup]="timelineForm" class="tablelist-form" autocomplete="off">
  
            <div class="row">
              <div class="col-12">
                <div class="mb-3">
  
                  @if (!showFilters) {
                    <!--
                    <div class="row">
                      <div class="col-12">
                        <div class="d-flex align-items-center justify-content-end w-100 gap-2">
                          <label>Show Filters</label>  
                          <div class="form-check form-switch form-switch-md">
                            <input class="form-check-input" type="checkbox" formControlName="filtersCheck" (click)="showFiltersClick()">
                          </div>
                        </div>
                      </div>
                    </div>
                    -->
                  } @else {
                    <div class="border border-success rounded" [class.usage-card-grow]="sureSimContainerGrow">
                      <div class="row">
                        <div class="col-12">
                          <div class="alert border-0 alert-primary" role="alert">
                            <strong>{{formTitle}}</strong>
                            <span class="position-absolute top-50 end-0 translate-middle-y px-2">
                              <button class="btn-close" type="button" (click)="closeFilterArea()"></button>
                            </span>
                          </div>
                        </div>
                      </div>
                              
                      <div class="row mb-3 px-2">
                        <div class="col-3">
                          <app-dropdown-company
                            [initialCompanyId]="curUserCompanyID"
                            [retainFirstBlankOption]="true"
                            (selectOnChangeEvent)="companyFilterOnChange($event)"
                          ></app-dropdown-company>
                        </div>
                              
                        <div class="col-3">
                          <app-dropdown-user #userSelector
                            [companyId]="curUserCompanyID"
                            [initialUserId]="curUserID"
                            [retainFirstBlankOption]="true"
                            [showCompanySureSimDevices]="true"
                            [showHierarchySureSimDevices]="false"
                            (selectOnChangeEvent)="userFilterOnChange($event)"
                          ></app-dropdown-user>
                        </div>
                              
                        <div class="col-2">
                          <app-dropdown-device #deviceSelector
                            [companyId]="curUserCompanyID"
                            [initialDeviceId]="filterDeviceID"
                            [retainFirstBlankOption]="true"
                            [showCompanySureSimDevices]="true"
                            [showHierarchySureSimDevices]="false"
                            (selectOnChangeEvent)="deviceFilterOnChange($event)"
                            (selectOnChangeIccidEvent)="deviceFilterOnChangeIccid($event)"
                          ></app-dropdown-device>
                        </div>
                              
                        <div class="col-2 text-center">
                          <label for="status-field" class="form-label">Status</label>
                          @if (getSimStatus(); as simStatus) {
                            <div id="status-field" class="form-control text-center {{getSimStatusBgClass()}}">
                              @if (simStatus.iconClass != "") {
                                <i class="{{simStatus.iconClass}} cell-icon align-middle me-1"></i>
                              }
                              <span class="align-middle">{{simStatus.statusDisplay}}</span>
                            </div>
                          }
                        </div>
                              
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
  
            <div class="row">
  
              <div class="col-2 d-flex flex-column"> <!-- Usage Details, Location Awareness, Timeline -->
                @if (timelineDisplayVersion2) {
                  <div class="row">
                    <div class="col-12">
                      <div class="mb-3">
                        <div class="border border-success rounded" [class.usage-card-grow]="sureSimContainerGrow">
                          <div class="row">
                            <div class="col-12">
                              <div class="alert border-0 alert-primary" role="alert">
                                <strong>Usage Details @if(dataLoaded && !sureSimLiveData) {<span style="color: #db2e46"> - No supplier data available</span>}</strong>
                              </div>
                            </div>
                          </div>
                         
                          <div class="row align-items-center">
                            <div class="col-5">
                              <div class="mb-0 px-2">
                                <label for="lastCountryUsage-field" class="form-label">Last Country</label>
                              </div>
                            </div>
                            <div class="col-7">
                              <div class="mb-0 px-2">
                                <div class="input-wrapper">
                                  <input autocomplete="no-fill" type="text" readonly id="lastCountryUsage-field" class="form-control text-end border-0" placeholder="" formControlName="lastCountryUsage" />
                                  @if(formData['lastCountryFlagIcon'].value != undefined && formData['lastCountryFlagIcon'].value.trim() != "") {
                                    <img width="16" [src]="formData['lastCountryFlagIcon'].value" alt="icon" class="input-icon-right">
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                         
                          <div class="row align-items-center">
                            <div class="col-6">
                              <div class="mb-0 px-2">
                                <label for="lastUsageDate-field" class="form-label">Last Usage</label>
                              </div>
                            </div>
                            <div class="col-6">
                              <div class="mb-0 px-2">
                               @if(sureSimLiveData) {
                                <input type="datetime" readonly id="lastUsageDate-field" class="form-control text-end border-0 compact-input last-usage-compact" placeholder="" formControlName="lastUsageDate" />
                               } @else {
                                <input type="datetime" readonly id="lastUsageDate-field" class="form-control text-end border-0" placeholder="" />
                               }
                              </div>
                            </div>
                          </div>
                         
                          <div class="row align-items-center">
                            <div class="col-6">
                              <div class="mb-0 px-2">
                                <label for="currentDayUsage-field" class="form-label">Usage Today</label>
                              </div>
                            </div>
                            <div class="col-6">
                              <div class="mb-0 px-2">
                               @if(sureSimLiveData) {
                                <input autocomplete="no-fill" type="text" readonly id="currentDayUsage-field" class="form-control text-end border-0" placeholder="" formControlName="currentDayUsage" />
                               } @else {
                                <input autocomplete="no-fill" type="text" readonly id="currentDayUsage-field" class="form-control text-end border-0" placeholder="" />
                               }
                              </div>
                            </div>
                          </div>

                          <div class="row align-items-center">
                            <div class="col-6">
                              <div class="mb-0 px-2">
                                <label for="currentMonthUsage-field" class="form-label">Usage {{filterDate?.date| date:'LLLL'}}</label>
                              </div>
                            </div>
                            <div class="col-6">
                              <div class="mb-0 px-2">
                               @if(sureSimLiveData) {
                                <input autocomplete="no-fill" type="text" readonly id="currentMonthUsage-field" class="form-control text-end border-0" placeholder="" formControlName="currentMonthUsage" />
                               } @else {
                                <input autocomplete="no-fill" type="text" readonly id="currentMonthUsage-field" class="form-control text-end border-0" placeholder="" />
                               }
                              </div>
                            </div>
                          </div>

                          <div class="row align-items-center">
                            <div class="col-6">
                              <div class="mb-0 px-2">
                                <label for="currentDaySessions-field" class="form-label">Sessions Today@if(sessionThresholdMB > 0) {<br><small class="text-muted fw-normal">{{sessionThresholdMB}}MB Threshold</small>}</label>
                              </div>
                            </div>
                            <div class="col-6">
                              <div class="mb-0 px-2">
                               @if(sureSimLiveData) {
                                <input autocomplete="no-fill" type="text" readonly id="currentDaySessions-field" class="form-control text-end border-0" placeholder="" formControlName="currentDaySessions" />
                               } @else {
                                <input autocomplete="no-fill" type="text" readonly id="currentDaySessions-field" class="form-control text-end border-0" placeholder="" />
                               }
                              </div>
                            </div>
                          </div>

                          <div class="row align-items-center">
                            <div class="col-6">
                              <div class="mb-0 px-2">
                                <label for="currentMonthSessions-field" class="form-label">Sessions {{filterDate?.date| date:'LLLL'}}@if(sessionThresholdMB > 0) {<br><small class="text-muted fw-normal">{{sessionThresholdMB}}MB Threshold</small>}</label>
                              </div>
                            </div>
                            <div class="col-6">
                              <div class="mb-0 px-2">
                               @if(sureSimLiveData) {
                                <input autocomplete="no-fill" type="text" readonly id="currentMonthSessions-field" class="form-control text-end border-0" placeholder="" formControlName="currentMonthSessions" />
                               } @else {
                                <input autocomplete="no-fill" type="text" readonly id="currentMonthSessions-field" class="form-control text-end border-0" placeholder="" />
                               }
                              </div>
                            </div>
                          </div>
                         
                          <div class="row align-items-center">
                            <div class="col-6">
                              <div class="mb-2 px-2">
                                <label for="currentMonthCost-field" class="form-label">Total Cost ({{filterDate?.date| date:'LLLL'}})</label>
                              </div>
                            </div>
                            <div class="col-6">
                              <div class="mb-2 px-2">
                               @if(sureSimLiveData) {
                                <input autocomplete="no-fill" type="text" readonly id="currentMonthCost-field" class="form-control text-end border-0" placeholder="" formControlName="currentMonthCost" />
                               } @else {
                                <input autocomplete="no-fill" type="text" readonly id="currentMonthCost-field" class="form-control text-end border-0" placeholder="" />
                               }
                              </div>
                            </div>
                          </div>
    
                        </div>
                      </div>
                    </div>
                  </div>
                }
                @if (timelineDisplayVersion2) {
                  <div class="row">
                    <div class="col-12">
                      <div class="mb-3">
                        <div class="border border-success rounded" [class.usage-card-grow]="sureSimContainerGrow">
                          <div class="row">
                            <div class="col-12">
                              <div class="alert border-0 alert-primary" role="alert">
                                <strong>Location Awareness @if(this.getLocationAwarenessText() != "") {<span style="color: #db2e46"> - {{this.getLocationAwarenessText()}}</span>}</strong>
                              </div>
                            </div>
                          </div>
                         
                          @if(this.getLocationAwarenessText() == "") {
                            <div class="row">
                              <div class="col-4">
                                <div class="mb-0 px-2">
                                  <label for="lastLocationCountry-field" class="form-label">Country</label>
                                </div>
                              </div>
                              <div class="col-8">
                                <div class="mb-0 px-2">
                                  <div class="input-wrapper">
                                    <input autocomplete="no-fill" type="text" readonly id="lastLocationCountry-field" class="form-control text-end border-0" placeholder="" formControlName="lastLocationCountry" />
                                    @if(formData['lastLocationCountryFlagIcon'].value != undefined && formData['lastLocationCountryFlagIcon'].value.trim() != "") {
                                      <img width="16" [src]="formData['lastLocationCountryFlagIcon'].value" alt="icon" class="input-icon-right">
                                    }
                                  </div>
                                </div>
                              </div>
                            </div>
  
                            <div class="row">
                              <div class="col-4">
                                <div class="mb-0 px-2">
                                  <label for="lastLocation-field" class="form-label">Location</label>
                                </div>
                              </div>
                              <div class="col-8">
                                <div class="mb-0 px-2">
                                  <input autocomplete="no-fill" type="text" readonly id="lastLocation-field" class="form-control text-end border-0" placeholder="" formControlName="lastLocation" />
                                </div>
                              </div>
                            </div>
                           
                            <div class="row">
                              <div class="col-4">
                                <div class="mb-0 px-2">
                                  <label for="lastLocationDate-field" class="form-label">Updated</label>
                                </div>
                              </div>
                              <div class="col-8">
                                <div class="mb-0 px-2">
                                 @if(sureSimLocationData) {
                                  <input type="datetime" readonly id="lastLocationDate-field" class="form-control text-end border-0 compact-input" placeholder="" formControlName="lastLocationDate" />
                                 } @else {
                                  <input type="datetime" readonly id="lastLocationDate-field" class="form-control text-end border-0" placeholder="" />
                                 }
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                }
                <div class="mb-3 flex-grow-1 d-flex flex-column">
                  <div class="border border-success rounded flex-grow-1" [class.usage-card-grow]="sureSimContainerGrow">
                    <div class="row">
                      <div class="col-12">
                        <div class="alert border-0 alert-primary w-100" role="alert">
                          <div class="d-flex align-items-center justify-content-between w-100">
                            <strong>Timeline</strong>
                            @if (!showFilters && !routePassedIccid &&!modalPassedIccid) {
                              <div class="d-flex align-items-center gap-2 text-muted">
                                <label>Show Filters</label>  
                                <div class="form-check form-switch form-switch-md">
                                  <input class="form-check-input" type="checkbox" formControlName="filtersCheck" (click)="showFiltersClick()">
                                </div>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <div
                          class="mb-3"
                          [ngStyle]="timelineDisplayVersion2 ? { 'min-height': '275px', 'max-height': '275px', 'overflow-y': 'auto' } : {}"
                        >
                          <app-page-comp-timeline
                            [liveTimeLineData]="liveTimeLineData"
                          ></app-page-comp-timeline>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> <!-- Timeline -->
  
              <div class="col-7 d-flex flex-column"> <!-- SIM Details | Device Details | Order Details | Usage Details | Todays Usage | Usage Per Day | SIM Activity -->
              
                <div class="row" [hidden]="timelineDisplayVersion2 && simActivityVisible">
                  <div class="col-5"> <!-- SIM Details | Device Details | Order Details -->
  
                    <div class="row">
                      <div class="col-12">
                        <div class="mb-3">
                          <div class="border border-success rounded" [class.usage-card-grow]="sureSimContainerGrow">
                            <div class="row">
                              <div class="col-12">
                                <div class="alert border-0 alert-primary d-flex justify-content-between px-3" role="alert">
                                  <strong>SIM Details</strong>
                                  <a *ngIf="showExpansionLinks" href="javascript:void(0);"
                                    [ngClass]="expandSimDetails ? 'bx bx-up-arrow' : 'bx bx-down-arrow'"
                                    [title]="expandSimDetails ? 'Collapse' : 'Expand'"
                                    (click)="simDetailsExpandClick()"
                                  ></a>
                                </div>
                              </div>
                            </div>
      
                            <div class="row" hidden="true">
                              <div class="col-3">
                                <div class="mb-0 px-2">
                                  <label for="deviceTypeId-field" class="form-label">SIM Type</label>
                                </div>
                              </div>
                              <div class="col-9">
                                <div class="mb-0 px-2">
                                  <select #deviceTypeId
                                    autocomplete="no-fill"
                                    class="form-select text-right"
                                    name="deviceTypeId-field"
                                    id="deviceTypeId-field"
                                    formControlName="deviceTypeId"
                                    [ngClass]="{ 'is-invalid': formSubmitted && formData['deviceTypeId'].errors }"
                                  >
                                    <option selected></option>
                                    @for (object of getDropdownDataObjectArray("deviceTypeId"); track object.id) {
                                      <option [ngValue]="object.id">{{object.description}}</option>    
                                    }
                                  </select>
                                  <div class="invalid-feedback">A value is required</div>
                                </div>
                              </div>
                            </div>
        
                            <div class="row">
                              <div class="col-3">
                                <div class="mb-0 px-2">
                                  <label for="deviceTypeIdInput-field" class="form-label">SIM Type</label>
                                </div>
                              </div>
                              <div class="col-9">
                                <div class="mb-0 px-2">
                                  @if(filterDeviceID != undefined && deviceTypeId.options != undefined && deviceTypeId.options[deviceTypeId.options.selectedIndex] != undefined) {
                                    <input autocomplete="no-fill" type="text" readonly id="deviceTypeIdInput-field" class="form-control text-end border-0" placeholder="" [value]="deviceTypeId.options[deviceTypeId.options.selectedIndex]?.text ?? ''" />
                                  } @else {
                                    <input autocomplete="no-fill" type="text" readonly id="deviceTypeIdInput-field" class="form-control text-end border-0" placeholder="" />
                                  }
                                </div>
                              </div>
                            </div>
      
                            @if (expandSimDetails) {
                              <div class="row">
                                <div class="col-3">
                                  <div class="mb-0 px-2">
                                    <label for="msisdn-field" class="form-label">MSISDN</label>
                                  </div>
                                </div>
                                <div class="col-9">
                                  <div class="mb-0 px-2">
                                    <input autocomplete="no-fill" type="text" readonly id="msisdn-field" class="form-control text-end border-0" placeholder="" formControlName="msisdn" [ngClass]="{ 'is-invalid': formSubmitted && formData['msisdn'].errors }" />
                                    @if(formData['msisdn'].hasError('maxlength')) {
                                      <div class="invalid-feedback">Maximum length of {{msisdnMaxLength}} characters has been exceeded</div>
                                    } @else {
                                      <div class="invalid-feedback">A value is required</div>
                                    }
                                  </div>
                                </div>
                              </div>
                            }
      
                            <div class="row">
                              <div class="col-3">
                                <div class="mb-0 px-2">
                                  <label for="iccid-field" class="form-label">ICCID</label>
                                </div>
                              </div>
                              <div class="col-9">
                                <div class="mb-0 px-2">
                                  <a (click)="enableMangeSimForm && viewDevice()">
                                    <input
                                      autocomplete="no-fill"
                                      class="form-control text-end border-0"
                                      id="iccid-field" 
                                      formControlName="iccid"
                                      placeholder=""
                                      [ngClass]="{
                                        'text-secondary': enableMangeSimForm,
                                        'is-invalid': formSubmitted && formData['iccid'].errors
                                      }"
                                      [ngStyle]="{ cursor: enableMangeSimForm ? 'pointer' : 'default' }"
                                      readonly
                                      type="text"
                                    />
                                  </a>
                                  <div class="invalid-feedback">A value is required</div>
                                </div>
                              </div>
                            </div>
      
                            <div class="row">
                              <div class="col-3">
                                <div class="mb-2 px-2">
                                  <label for="eid-field" class="form-label">EID</label>
                                </div>
                              </div>
                              <div class="col-9">
                                <div class="mb-2 px-2">
                                  <input autocomplete="no-fill" type="text" readonly id="eid-field" class="form-control text-end border-0" placeholder="" formControlName="eid" [ngClass]="{ 'is-invalid': formSubmitted && formData['eid'].errors }" />
                                  <div class="invalid-feedback">A value is required</div>
                                </div>
                              </div>
                            </div>
      
                          </div>
                        </div>
                      </div>
                    </div>
      
                    <div class="row">
                      <div class="col-12">
                        <div class="mb-3">
                          <div class="border border-success rounded" [class.usage-card-grow]="sureSimContainerGrow">
                            <div class="row">
                              <div class="col-12">
                                <div class="alert border-0 alert-primary d-flex justify-content-between px-3" role="alert">
                                  <strong>
                                    {{ timelineDisplayVersion2 ? 'Device & Current Network Details' : 'Device Details' }}
                                    @if(dataLoaded && !sureSimLiveData) {<span style="color: #db2e46"> - No supplier data available</span>}
                                    @if(dataLoaded && sureSimLiveData && (!sureSimLiveData.Vendor && !sureSimLiveData.PDP)) {<span style="color: #db2e46"> - No recent data</span>}
                                  </strong>
                                  <a *ngIf="showExpansionLinks" href="javascript:void(0);"
                                    [ngClass]="expandDeviceDetails ? 'bx bx-up-arrow' : 'bx bx-down-arrow'"
                                    [title]="expandDeviceDetails ? 'Collapse' : 'Expand'"
                                    (click)="deviceDetailsExpandClick()"
                                  ></a>
                                </div>
                              </div>
                            </div>
      
                            <div class="row">
                              <div class="col-3">
                                <div class="mb-0 px-2">
                                  <label for="liveVendor-field" class="form-label">Vendor</label>
                                </div>
                              </div>
                              <div class="col-9">
                                <div class="mb-0 px-2">
                                  <input autocomplete="no-fill" type="text" readonly id="liveVendor-field" class="form-control text-end border-0" placeholder="" formControlName="liveVendor" />
                                </div>
                              </div>
                            </div>
      
                            <div class="row">
                              <div class="col-3">
                                <div class="mb-0 px-2">
                                  <label for="liveModel-field" class="form-label">Model</label>
                                </div>
                              </div>
                              <div class="col-9">
                                <div class="mb-0 px-2">
                                  <input autocomplete="no-fill" type="text" readonly id="liveModel-field" class="form-control text-end border-0" placeholder="" formControlName="liveModel" />
                                </div>
                              </div>
                            </div>
      
                            <div class="row">
                              <div class="col-3">
                                <div class="mb-0 px-2">
                                  <label for="liveImei-field" class="form-label">IMEI</label>
                                </div>
                              </div>
                              <div class="col-9">
                                <div class="mb-0 px-2">
                                  <input autocomplete="no-fill" type="text" readonly id="liveImei-field" class="form-control text-end border-0" placeholder="" formControlName="liveImei" />
                                </div>
                              </div>
                            </div>

                            @if (expandDeviceDetails) {
                              <div class="row">
                                <div class="col-3">
                                  <div class="mb-0 px-2">
                                    <label for="liveVplmn-field" class="form-label">VPLMN</label>
                                  </div>
                                </div>
                                <div class="col-9">
                                  <div class="mb-0 px-2">
                                    <input autocomplete="no-fill" type="text" readonly id="liveVplmn-field" class="form-control text-end border-0" placeholder="" formControlName="liveVplmn" />
                                  </div>
                                </div>
                              </div>
  
                              <div class="row">
                                <div class="col-3">
                                  <div class="mb-0 px-2">
                                    <label for="liveApn-field" class="form-label">APN</label>
                                  </div>
                                </div>
                                <div class="col-9">
                                  <div class="mb-0 px-2">
                                    <input autocomplete="no-fill" type="text" readonly id="liveApn-field" class="form-control text-end border-0" placeholder="" formControlName="liveApn" />
                                  </div>
                                </div>
                              </div>
  
                              <div class="row">
                                <div class="col-3">
                                  <div class="mb-0 px-2">
                                    <label for="liveIp-field" class="form-label">IP</label>
                                  </div>
                                </div>
                                <div class="col-9">
                                  <div class="mb-0 px-2">
                                    <input autocomplete="no-fill" type="text" readonly id="liveIp-field" class="form-control text-end border-0" placeholder="" formControlName="liveIp" />
                                  </div>
                                </div>
                              </div>
  
                              <div class="row">
                                <div class="col-6">
                                  <div class="mb-0 px-2">
                                    <label for="livePdp-field" class="form-label">Last Data Session Start Time (PDP)</label>
                                  </div>
                                </div>
                                <div class="col-6">
                                  <div class="mb-2 px-2">
                                    <input autocomplete="no-fill" type="text" readonly id="livePdp-field" class="form-control text-end border-0" placeholder="" formControlName="livePdp" />
                                  </div>
                                </div>
                              </div>
                            }
      
                          </div>
                        </div>
                      </div>
                    </div>
      
                    <div class="row">
                      <div class="col-12">
                        <div class="mb-3">
                          <div class="border border-success rounded" [class.usage-card-grow]="sureSimContainerGrow">
                            <div class="row">
                              <div class="col-12">
                                <div class="alert border-0 alert-primary d-flex justify-content-between px-3" role="alert">
                                  <strong>Order Details</strong>
                                  <a *ngIf="showExpansionLinks" href="javascript:void(0);"
                                    [ngClass]="expandOrderDetails ? 'bx bx-up-arrow' : 'bx bx-down-arrow'"
                                    [title]="expandOrderDetails ? 'Collapse' : 'Expand'"
                                    (click)="orderDetailsExpandClick()"
                                  ></a>
                                </div>
                              </div>
                            </div>
      
                            <div class="row">
                              <div class="col-4">
                                <div class="mb-0 px-2">
                                 <label for="orderNo-field" class="form-label">Order No</label>
                                </div>
                              </div>
                              <div class="col-8">
                                <div class="mb-0 px-2">
                                 <input autocomplete="no-fill" type="text" readonly id="orderNo-field" class="form-control text-end border-0" placeholder="" formControlName="orderNo" [ngClass]="{ 'is-invalid': formSubmitted && formData['orderNo'].errors }" />
                                 @if(formData['orderNo'].hasError('maxlength')) {
                                   <div class="invalid-feedback">Maximum length of {{orderNoMaxLength}} characters has been exceeded</div>
                                 } @else {
                                   <div class="invalid-feedback">A value is required</div>
                                 }
                                </div>
                              </div>
                            </div>
      
                            @if (expandOrderDetails) {
                              <div class="row">
                                <div class="col-4">
                                  <div class="mb-0 px-2">
                                   <label for="supplierOrderNo-field" class="form-label">Supplier Order</label>
                                  </div>
                                </div>
                                <div class="col-8">
                                  <div class="mb-0 px-2">
                                   <input autocomplete="no-fill" type="text" readonly id="supplierOrderNo-field" class="form-control text-end border-0" placeholder="" formControlName="supplierOrderNo" [ngClass]="{ 'is-invalid': formSubmitted && formData['supplierOrderNo'].errors }" />
                                   @if(formData['supplierOrderNo'].hasError('maxlength')) {
                                     <div class="invalid-feedback">Maximum length of {{supplierOrderNoMaxLength}} characters has been exceeded</div>
                                   } @else {
                                     <div class="invalid-feedback">A value is required</div>
                                   }
                                  </div>
                                </div>
                              </div>
                            }
      
                            <div class="row" hidden="true">
                              <div class="col-4">
                                <div class="mb-0 px-2">
                                  <label for="companyId-field" class="form-label text-right">Company</label>
                                </div>
                              </div>
                              <div class="col-8">
                                <div class="mb-0 px-2">
                                  <div class="input-group">
                                    <select #companyId
                                      class="form-select"
                                      name="companyId-field"
                                      id="companyId-field"
                                      formControlName="companyId"
                                      (change)="companySelectDropDownChange($event)"
                                      [ngClass]="{ 'is-invalid': formSubmitted && formData['companyId'].errors }"
                                    >
                                      <option selected></option>
                                      @for (object of getDropdownDataObjectArray_Company(); track object.id) {
                                        <option [ngValue]="object.id">{{object.companyName}}</option>    
                                      }
                                    </select>
                                    <button class="btn btn-success" type="button" (click)="viewCompany()">View</button>
                                  </div>
                                  <div class="invalid-feedback">A value is required</div>
                                </div>
                              </div>
                            </div>
      
                            <div class="row">
                              <div class="col-4">
                                <div class="mb-0 px-2">
                                  <label for="companyIdInput-field" class="form-label">Company</label>
                                </div>
                              </div>
                              <div class="col-8">
                                <div class="mb-0 px-2">
                                  @if(filterDeviceID != undefined && companyId.options.selectedIndex != undefined && companyId.options.selectedIndex>=0 && companyId.options[companyId.options.selectedIndex] != undefined) {
                                    <a (click)="viewCompany()">
                                      <input
                                        autocomplete="no-fill"
                                        class="form-control text-end border-0"
                                        id="companyIdInput-field" 
                                        placeholder=""
                                        [ngClass]="{ 'text-secondary': true }"
                                        readonly
                                        style="cursor: pointer"
                                        type="text"
                                        [value]="companyId.options[companyId.options.selectedIndex]?.text ?? ''"
                                      />
                                    </a>
                                  } @else {
                                    <input autocomplete="no-fill" type="text" readonly id="companyIdInput-field" class="form-control text-end border-0" placeholder="" />
                                  }
                                </div>
                              </div>
                            </div>
      
                            <div class="row" hidden="true">
                              <div class="col-3">
                                <div class="mb-0 px-2">
                                 <label for="userId-field" class="form-label text-right">User</label>
                                </div>
                              </div>
                              <div class="col-9">
                                <div class="mb-0 px-2">
                                 <div class="input-group">
                                   <select #userId
                                     class="form-select"
                                     name="userId-field"
                                     id="userId-field"
                                     formControlName="userId"
                                     (change)="userSelectDropDownChange($event)"
                                     [ngClass]="{ 'is-invalid': formSubmitted && formData['userId'].errors }"
                                   >
                                     <option selected></option>
                                     @for (object of getDropdownDataObjectArray("userId"); track object.id) {
                                       <option [ngValue]="object.id">{{object.description}}</option>    
                                     }
                                   </select>
                                   <button class="btn btn-success" type="button" (click)="viewUser()">View</button>
                                 </div>
                                 <div class="invalid-feedback">A value is required</div>
                                </div>
                              </div>
                            </div>
       
                            <div class="row">
                              <div class="col-3">
                                <div class="mb-0 px-2">
                                  <label for="userIdInput-field" class="form-label">{{fieldAliasUsername}}</label>
                                </div>
                              </div>
                              <div class="col-9">
                                <div class="mb-0 px-2">
                                 @if (filterDeviceID != undefined && userId.options.selectedIndex != undefined && userId.options[userId.options.selectedIndex] != undefined) {
                                  <a (click)="viewUser()">
                                    <input
                                      autocomplete="no-fill"
                                      class="form-control text-end border-0"
                                      id="userIdInput-field" 
                                      placeholder=""
                                      [ngClass]="{ 'text-secondary': true }"
                                      readonly
                                      style="cursor: pointer"
                                      type="text"
                                      [value]="userId.options[userId.options.selectedIndex]?.text ?? ''"
                                    />
                                  </a>
                                  } @else {
                                    <input autocomplete="no-fill" type="text" readonly id="userIdInput-field" class="form-control text-end border-0" placeholder="" />
                                  }
                                </div>
                              </div>
                            </div>
                                           
                            @if (expandOrderDetails) {
                              <div class="row">
                                <div class="col-3">
                                  <div class="mb-0 px-2">
                                   <label for="email-field" class="form-label">Email</label>
                                  </div>
                                </div>
                                <div class="col-9">
                                  <div class="mb-0 px-2">
                                   <input autocomplete="no-fill" type="text" readonly id="email-field" class="form-control text-end border-0" placeholder="" formControlName="email" [ngClass]="{ 'is-invalid': formSubmitted && formData['email'].errors }" />
                                   @if(formData['email'].hasError('maxlength')) {
                                     <div class="invalid-feedback">Maximum length of {{emailMaxLength}} characters has been exceeded</div>
                                   } @else {
                                     <div class="invalid-feedback">A value is required</div>
                                   }
                                  </div>
                                </div>
                              </div>
                            }
      
                            <div class="row">
                              <div class="col-3">
                                <div class="mb-0 px-2">
                                 <label for="mobileNumber-field" class="form-label">Mobile</label>
                                </div>
                              </div>
                              <div class="col-9">
                                <div class="mb-0 px-2">
                                 <input autocomplete="no-fill" type="text" readonly id="mobileNumber-field" class="form-control text-end border-0" placeholder="" formControlName="mobileNumber" [ngClass]="{ 'is-invalid': formSubmitted && formData['mobileNumber'].errors }" />
                                 @if(formData['mobileNumber'].hasError('maxlength')) {
                                   <div class="invalid-feedback">Maximum length of {{mobileNumberMaxLength}} characters has been exceeded</div>
                                 } @else {
                                   <div class="invalid-feedback">A value is required</div>
                                 }
                                </div>
                              </div>
                            </div>
      
                            @if (expandOrderDetails) {
                              <div class="row">
                                <div class="col-3">
                                  <div class="mb-0 px-2">
                                   <label for="customerTag-field" class="form-label">Tag</label>
                                  </div>
                                </div>
                                <div class="col-9">
                                  <div class="mb-0 px-2">
                                   <input autocomplete="no-fill" type="text" readonly id="customerTag-field" class="form-control text-end border-0" placeholder="" formControlName="customerTag" [ngClass]="{ 'is-invalid': formSubmitted && formData['customerTag'].errors }" />
                                   @if(formData['customerTag'].hasError('maxlength')) {
                                     <div class="invalid-feedback">Maximum length of {{customerTagMaxLength}} characters has been exceeded</div>
                                   } @else {
                                     <div class="invalid-feedback">A value is required</div>
                                   }
                                  </div>
                                </div>
                              </div>
                            }
      
                            <div class="row" hidden="true">
                              <div class="col-3">
                                <div class="mb-0 px-2">
                                 <label for="productId-field" class="form-label text-right">Product</label>
                                </div>
                              </div>
                              <div class="col-9">
                                <div class="mb-0 px-2">
                                  <select #productId
                                    class="form-select text-right"
                                    name="productId-field"
                                    id="productId-field"
                                    formControlName="productId"
                                    [ngClass]="{ 'is-invalid': formSubmitted && formData['productId'].errors }"
                                  >
                                    <option selected></option>
                                    @for (object of getDropdownDataObjectArray("productId"); track object.id) {
                                      <option [ngValue]="object.id">{{object.description}}</option>    
                                    }
                                  </select>
                                  <div class="invalid-feedback">A value is required</div>
                                </div>
                              </div>
                            </div>
       
                            <div class="row">
                              <div class="col-3">
                                <div class="mb-2 px-2">
                                  <label for="productIdInput-field" class="form-label">Product</label>
                                </div>
                              </div>
                              <div class="col-9">
                                <div class="mb-2 px-2">
                                  @if (filterDeviceID != undefined && productId.options.selectedIndex != undefined && productId.options[productId.options.selectedIndex] != undefined) {
                                    <input
                                      autocomplete="no-fill"
                                      class="form-control text-end border-0"
                                      id="productIdInput-field" 
                                      placeholder=""
                                      readonly
                                      type="text"
                                      [value]="productId.options[productId.options.selectedIndex]?.text ?? ''"
                                    />
                                  } @else {
                                    <input autocomplete="no-fill" type="text" readonly id="productIdInput-field" class="form-control text-end border-0" placeholder="" />
                                  }
                                </div>
                              </div>
                            </div>
      
                          </div>
                        </div>
                      </div>
                    </div>
      
                  </div> <!-- SIM Details | Device Details | Order Details -->
      
                  <div class="col-7 d-flex flex-column"> <!-- Usage Details | Todays Usage | Usage Per Day -->
                    @if (!timelineDisplayVersion2) {
                      <div class="row">
                        <div class="col-12">
                          <div class="mb-3">
                            <div class="border border-success rounded" [class.usage-card-grow]="sureSimContainerGrow">
                              <div class="row">
                                <div class="col-12">
                                  <div class="alert border-0 alert-primary" role="alert">
                                    <strong>Usage Details @if(dataLoaded && !sureSimLiveData) {<span style="color: #db2e46"> - No supplier data available</span>}</strong>
                                  </div>
                                </div>
                              </div>
                             
                              <div class="row">
                                <div class="col-5">
                                  <div class="mb-0 px-2">
                                    <label for="lastCountryUsage-field" class="form-label">Last Country</label>
                                  </div>
                                </div>
                                <div class="col-7">
                                  <div class="mb-0 px-2">
                                    <div class="input-wrapper">
                                      <input autocomplete="no-fill" type="text" readonly id="lastCountryUsage-field" class="form-control text-end border-0" placeholder="" formControlName="lastCountryUsage" />
                                      @if(formData['lastCountryFlagIcon'].value != undefined && formData['lastCountryFlagIcon'].value.trim() != "") {
                                        <img width="16" [src]="formData['lastCountryFlagIcon'].value" alt="icon" class="input-icon-right">
                                      }
                                    </div>
                                  </div>
                                </div>
                              </div>
                             
                              <div class="row">
                                <div class="col-6">
                                  <div class="mb-0 px-2">
                                    <label for="lastUsageDate-field" class="form-label">Last Usage</label>
                                  </div>
                                </div>
                                <div class="col-6">
                                  <div class="mb-0 px-2">
                                   @if(sureSimLiveData) {
                                    <input type="datetime" readonly id="lastUsageDate-field" class="form-control text-end border-0" placeholder="" formControlName="lastUsageDate" />
                                   } @else {
                                    <input type="datetime" readonly id="lastUsageDate-field" class="form-control text-end border-0" placeholder="" />
                                   }
                                  </div>
                                </div>
                              </div>
                             
                              <div class="row">
                                <div class="col-6">
                                  <div class="mb-0 px-2">
                                    <label for="currentDaySessions-field" class="form-label">Total Sessions (Today)@if(sessionThresholdMB > 0) {<br><small class="text-muted fw-normal">{{sessionThresholdMB}}MB Threshold</small>}</label>
                                  </div>
                                </div>
                                <div class="col-6">
                                  <div class="mb-0 px-2">
                                   @if(sureSimLiveData) {
                                    <input autocomplete="no-fill" type="text" readonly id="currentDaySessions-field" class="form-control text-end border-0" placeholder="" formControlName="currentDaySessions" />
                                   } @else {
                                    <input autocomplete="no-fill" type="text" readonly id="currentDaySessions-field" class="form-control text-end border-0" placeholder="" />
                                   }
                                  </div>
                                </div>
                              </div>

                              <div class="row">
                                <div class="col-6">
                                  <div class="mb-0 px-2">
                                    <label for="currentDayUsage-field" class="form-label">Total Usage (Today)</label>
                                  </div>
                                </div>
                                <div class="col-6">
                                  <div class="mb-0 px-2">
                                   @if(sureSimLiveData) {
                                    <input autocomplete="no-fill" type="text" readonly id="currentDayUsage-field" class="form-control text-end border-0" placeholder="" formControlName="currentDayUsage" />
                                   } @else {
                                    <input autocomplete="no-fill" type="text" readonly id="currentDayUsage-field" class="form-control text-end border-0" placeholder="" />
                                   }
                                  </div>
                                </div>
                              </div>

                              <div class="row">
                                <div class="col-6">
                                  <div class="mb-0 px-2">
                                    <label for="currentMonthSessions-field" class="form-label">Total Sessions ({{filterDate?.date| date:'LLLL'}})@if(sessionThresholdMB > 0) {<br><small class="text-muted fw-normal">{{sessionThresholdMB}}MB Threshold</small>}</label>
                                  </div>
                                </div>
                                <div class="col-6">
                                  <div class="mb-0 px-2">
                                   @if(sureSimLiveData) {
                                    <input autocomplete="no-fill" type="text" readonly id="currentMonthSessions-field" class="form-control text-end border-0" placeholder="" formControlName="currentMonthSessions" />
                                   } @else {
                                    <input autocomplete="no-fill" type="text" readonly id="currentMonthSessions-field" class="form-control text-end border-0" placeholder="" />
                                   }
                                  </div>
                                </div>
                              </div>

                              <div class="row">
                                <div class="col-6">
                                  <div class="mb-0 px-2">
                                    <label for="currentMonthUsage-field" class="form-label">Total Usage ({{filterDate?.date| date:'LLLL'}})</label>
                                  </div>
                                </div>
                                <div class="col-6">
                                  <div class="mb-0 px-2">
                                   @if(sureSimLiveData) {
                                    <input autocomplete="no-fill" type="text" readonly id="currentMonthUsage-field" class="form-control text-end border-0" placeholder="" formControlName="currentMonthUsage" />
                                   } @else {
                                    <input autocomplete="no-fill" type="text" readonly id="currentMonthUsage-field" class="form-control text-end border-0" placeholder="" />
                                   }
                                  </div>
                                </div>
                              </div>
                             
                              <div class="row">
                                <div class="col-6">
                                  <div class="mb-2 px-2">
                                    <label for="currentMonthCost-field" class="form-label">Total Cost ({{filterDate?.date| date:'LLLL'}})</label>
                                  </div>
                                </div>
                                <div class="col-6">
                                  <div class="mb-2 px-2">
                                   @if(sureSimLiveData) {
                                    <input autocomplete="no-fill" type="text" readonly id="currentMonthCost-field" class="form-control text-end border-0" placeholder="" formControlName="currentMonthCost" />
                                   } @else {
                                    <input autocomplete="no-fill" type="text" readonly id="currentMonthCost-field" class="form-control text-end border-0" placeholder="" />
                                   }
                                  </div>
                                </div>
                              </div>
        
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                    <div class="row">
                      <div class="col-12">
                        <div class="mb-3">
                          <app-chart-todays-usage #chartTodaysUsage
                            [chartHeight]="233"
                            [chartTitle]="'Todays Usage' + (todayUsageTotalSymbol ? ' (' + todayUsageTotalSymbol + ')' : '')"
                            [containerGrow]="sureSimContainerGrow"
                          ></app-chart-todays-usage>
                        </div>
                      </div>
                    </div>

                    <div class="row flex-grow-1">
                      <div class="col-12 d-flex flex-column flex-grow-1">
                        <div class="mb-3 flex-grow-1 d-flex flex-column">
                          <app-chart-usage-per-day #chartUsagePerDay
                            class="flex-grow-1 d-flex flex-column"
                            [chartHeight]="232"
                            [containerGrow]="sureSimContainerGrow"
                            [evenDaysOnly]="true"
                          ></app-chart-usage-per-day>
                        </div>
                      </div>
                    </div>
                  </div> <!-- Usage Details | Todays Usage | Usage Per Day -->
                </div>
                <div class="flex-grow-1 d-flex flex-column">
                    <div class="mb-3 flex-grow-1 d-flex flex-column">
                      <div class="border border-success rounded flex-grow-1" [class.usage-card-grow]="sureSimContainerGrow">
                        <div class="row">
                          <div class="col-12">
                            <div class="alert border-0 alert-primary mb-0" role="alert">
                              <i class="position-absolute end-0 top-50 translate-middle-y fs-5"
                                [ngClass]="timelineDisplayVersion2 ? (simActivityVisible ? 'bx bx-down-arrow' : 'bx bx-up-arrow') : null"
                                [title]="timelineDisplayVersion2 ? (simActivityVisible ? 'Collapse' : 'Bring to Top') : null"
                                (click)="toggleHeatmapVisibility()"
                                style="cursor: pointer; color: #198754; margin-right: 12px;"
                              ></i>
                              <strong>{{ timelineDisplayVersion2 ? '30 Minute SIM Usage Activity' : 'SIM Activity' }}</strong>
                            </div>
                          </div>
                        </div>
                        <div class="row" *ngIf="simActivityVisible">
                          <div class="col-12">
                            <div class="card">
                              <!--
                              <div class="card-header">
                                <h4 class="card-title mb-0">Basic Heatmap Chart</h4>
                              </div>
                              -->
                              <div class="card-body pt-2 pb-1 px-1">
                                <app-timeline-activity-heatmap #activityHeatmap
                                ></app-timeline-activity-heatmap>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
  
              </div> <!-- SIM Details | Device Details | Order Details | Usage Details | Todays Usage | Usage Per Day | SIM Activity -->
  
              <div class="col-3 d-flex flex-column"> <!-- Application Usage Summary | Country Usage Summary | Country Details -->

                @if (showApplicationContainer) {
                  <div class="row">
                    <div class="col-12">
                      <div class="mb-3">
                        <div class="border border-success rounded" [class.usage-card-grow]="sureSimContainerGrow">
                          <div class="row">
                            <div class="col-12">
                              <div class="alert border-0 alert-primary d-flex justify-content-between px-3" role="alert">
                                <strong>Application Usage Summary</strong>
                                  <a *ngIf="showExpansionLinks" href="javascript:void(0);"
                                    [ngClass]="expandApplicationUsage ? 'bx bx-up-arrow' : 'bx bx-down-arrow'"
                                    [title]="expandApplicationUsage ? 'Collapse' : 'Expand'"
                                    (click)="applicationUsageExpandClick()"
                                  ></a>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12">
                              @if (applicationChartUsage != undefined && showApplicationChart) {
                                <div class="card-body" style="padding-left: 10px;padding-right: 10px;">
                                  <apx-chart #applicationChartRef
                                    [chart]="applicationChartUsage.chart"
                                    [colors]="applicationChartUsage.colors"
                                    dir="ltr"
                                    [fill]="applicationChartUsage.fill"
                                    [labels]="applicationChartUsage.labels"
                                    [legend]="applicationChartUsage.legend"
                                    [markers]="applicationChartUsage.markers"
                                    [plotOptions]="applicationChartUsage.plotOptions"
                                    [dataLabels]="applicationChartUsage.dataLabels"
                                    [series]="applicationChartUsage.series"
                                    [stroke]="applicationChartUsage.stroke"
                                    [title]="applicationChartUsage.title"
                                    [tooltip]="applicationChartUsage.tooltip"
                                    [xaxis]="applicationChartUsage.xaxis"
                                    [yaxis]="applicationChartUsage.yaxis"
                                  >
                                  </apx-chart>
                                </div>
                              } @else if (!showApplicationChart) {
                                <div class="card">
                                  <!--
                                  <div class="card-header align-items-center d-flex">
                                    <h5 class="card-title mb-0 flex-grow-1">Country Usage Summary</h5>
                                  </div>
                                  -->
                                  <div class="card-body pt-0 ps-0">
                                    
                                    <div class="table-responsive table-card overflow-auto">
                                      <div class="pt-0 ps-3" [style.height.px]="(containerHeightApplication + 5)">
                                        <app-application-usage-summary
                                          [applicationUsageSummary]="applicationUsageSummaryGrid"
                                        ></app-application-usage-summary>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              } @else {
                                <div class="card">
                                  <div class="card-body pt-0 ps-0">
                                    <div class="table-responsive table-card overflow-auto">
                                      <div class="pt-0 ps-3" [style.height.px]="containerHeightApplication">
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }

                <div class="row" #countryUsageContainer>
                  <div class="col-12">
                    <div class="mb-3">
                      <div class="border border-success rounded" [class.usage-card-grow]="sureSimContainerGrow">
                        <div class="row">
                          <div class="col-12">
                            <div class="alert border-0 alert-primary d-flex justify-content-between px-3" role="alert">
                              <strong>Country Usage Summary</strong>
                                <a *ngIf="showExpansionLinks" href="javascript:void(0);"
                                  [ngClass]="expandCountrySummary ? 'bx bx-up-arrow' : 'bx bx-down-arrow'"
                                  [title]="expandCountrySummary ? 'Collapse' : 'Expand'"
                                  (click)="countrySummaryExpandClick()"
                                ></a>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12">
                            <div class="card">
                              <!--
                              <div class="card-header align-items-center d-flex">
                                <h5 class="card-title mb-0 flex-grow-1">Country Usage Summary</h5>
                              </div>
                              -->
                              <div class="card-body pt-0 ps-0">
                                
                                <div class="table-responsive table-card overflow-auto">
                                  <div class="pt-0 ps-3" [style.height.px]="containerHeightCountryUsage">
                                    <app-country-usage-summary
                                      [countryUsageSummary]="countryUsageSummary"
                                    ></app-country-usage-summary>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
  
                <div class="flex-grow-1 d-flex flex-column">
                    <div class="mb-3 flex-grow-1 d-flex flex-column">
                      <div class="border border-success rounded flex-grow-1" [class.usage-card-grow]="sureSimContainerGrow">
                        <div class="row">
                          <div class="col-12">
                            <div class="alert border-0 alert-primary d-flex justify-content-between px-3" role="alert">
                              <strong>{{ timelineDisplayVersion2 ? 'Usage by Day & Country' : 'Country Details' }}</strong>
                                <a *ngIf="showExpansionLinks" href="javascript:void(0);"
                                  [ngClass]="expandCountryDay ? 'bx bx-up-arrow' : 'bx bx-down-arrow'"
                                  [title]="expandCountryDay ? 'Collapse' : 'Expand'"
                                  (click)="countryDayExpandClick()"
                                ></a>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12">
                            <div class="card">
                              <!--
                              <div class="card-header align-items-center d-flex">
                                <h5 class="card-title mb-0 flex-grow-1">Country Usage Summary</h5>
                              </div>
                              -->
                              <div class="card-body pt-0 ps-0">
                                
                                <div class="table-responsive table-card overflow-auto">
                                  <div class="pt-0 ps-3" [style.height.px]="containerHeightCountryDetails">
                                    <app-country-details
                                      [countryDetails]="countryDetails"
                                    ></app-country-details>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
  
              </div> <!-- Country Usage Summary | Country Details -->
            </div>
  
        </form>
      </div>
      <div [className]="embeddedFormMode && !useFullPage ? 'col-3' : 'col-0'"></div>
    </div>
  </div>

  <!--
  @if(!embeddedFormMode) {
    <div class="modal-footer live-view-footer">
      <button type="button" class="btn btn-danger" data-bs-dismiss="modal" (click)="closeForm();modal.close('Close click')">Close</button>
    </div>
  }
  -->
</ng-template>

<app-company-modal-form #companyModalForm
  (companyFormCancelled)="companyFormHasBeenCancelled()"
  (sureSimCompanyDataHasBeenSaved)="companyDataHasBeenSaved($event)"
></app-company-modal-form>

@if(enableMangeSimForm) {
  <app-manage-esim-modal-form #manageEsimModalForm
    [disableTimelineIcon]="true"
    (orderDataHasBeenSaved)="orderDataHasBeenSaved()"
    (eSimManagerFormCancelled)="manageEsimFormHasBeenCancelled()"
  ></app-manage-esim-modal-form>
}

<app-user-modal-form #userModalForm
  (sureSimUserDataHasBeenSaved)="sureSimUserHasBeenSaved($event)"
  (userFormCancelled)="userFormHasBeenCancelled()"
></app-user-modal-form>
  
<app-warning-modal-form #warningModalForm
></app-warning-modal-form>
